"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.get = exports.dataMap = exports.dataList = exports.EBuyType = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var EBuyType;
(function (EBuyType) {
    EBuyType[EBuyType["default"] = -1] = "default";
    EBuyType[EBuyType["crew"] = 1] = "crew";
    EBuyType[EBuyType["item"] = 2] = "item";
})(EBuyType = exports.EBuyType || (exports.EBuyType = {}));
var _default = {
    type: 'Default',
    kind: EBuyType.default,
    cost: 99999,
    //canBuy: false,
    item: null,
    isCrew: false,
};
exports.dataList = [];
exports.dataMap = {};
var dataType = 'voyage-buy';
var get = function (name) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetData(dataType, exports.dataMap, name);
};
exports.get = get;
var register = function (data) {
    entitiesUtils_sidecar_1.entitiesUtils.genericRegisterData(dataType, data, _default, exports.dataList, exports.dataMap);
};
function registerAll() {
    register({
        type: 'Crew',
        kind: EBuyType.crew,
        cost: 250,
        isCrew: true,
    });
    register({
        type: 'Fire extinguisher',
        kind: EBuyType.item,
        cost: 100,
        item: voyageCarryableData_1.EVoyageCarryableType.Extinguisher,
    });
    register({
        type: 'Wrench',
        kind: EBuyType.item,
        cost: 100,
        item: voyageCarryableData_1.EVoyageCarryableType.Wrench,
    });
    register({
        type: 'Mop',
        kind: EBuyType.item,
        cost: 50,
        item: voyageCarryableData_1.EVoyageCarryableType.Mop,
    });
    register({
        type: 'Medpack',
        kind: EBuyType.item,
        cost: 200,
        item: voyageCarryableData_1.EVoyageCarryableType.Medpack,
    });
    register({
        type: 'Battle rifle',
        kind: EBuyType.item,
        cost: 200,
        item: voyageCarryableData_1.EVoyageCarryableType.BattleRifle,
    });
    register({
        type: 'Torpedo',
        kind: EBuyType.item,
        cost: 50,
        item: voyageCarryableData_1.EVoyageCarryableType.Torpedo,
    });
}
exports.registerAll = registerAll;
